import filterService from "app/pages/sales-intelligence/sub-modules/signals/services/filters/filterService";
import createSignalsValidationService from "app/pages/sales-intelligence/sub-modules/signals/services/validation/factory";

const signalsValidationService = createSignalsValidationService({ filterService });

export default signalsValidationService;
